import { ComponentIds, } from "@inter-ikea-core/core";
import { Alignment, ZoneUnit, From } from "./validationTypes";
const percentageToMillimeters = (height) => (percentage) => (height * percentage) / 100;
const flipPosition = (height) => (positionInMillimeters) => height - positionInMillimeters;
const getAbsoluteLimits = (entity, zone) => {
    var _a, _b, _c, _d;
    const entityHeight = (_b = (_a = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.Y;
    if (!entityHeight)
        return null;
    const entityPositionYMiddle = (_d = (_c = entity.getComponent(ComponentIds.LOCAL_TRANSFORM_COMPONENT_ID)) === null || _c === void 0 ? void 0 : _c.transform.position) === null || _d === void 0 ? void 0 : _d.Y;
    if (!entityPositionYMiddle)
        return null;
    const entityPositionY = entityPositionYMiddle - entityHeight / 2;
    const entityPercentageToMillimeters = percentageToMillimeters(entityHeight);
    const entityFlipPosition = flipPosition(entityHeight);
    // First we just take the values from the zone data without modification.
    let limits = {
        min: zone.min.value,
        max: zone.max.value,
    };
    // ...next we convert to millimeters if the zone data was given as a percentage.
    limits = {
        min: zone.min.unit === ZoneUnit.Percent
            ? entityPercentageToMillimeters(limits.min)
            : limits.min,
        max: zone.max.unit === ZoneUnit.Percent
            ? entityPercentageToMillimeters(limits.max)
            : limits.max,
    };
    // ...then we take into account whether we should count from the top or the bottom.
    limits = {
        min: zone.min.from === From.Top ? entityFlipPosition(limits.min) : limits.min,
        max: zone.max.from === From.Top ? entityFlipPosition(limits.max) : limits.max,
    };
    // ...and finally we add the entity position to get the absolute limit.
    limits = {
        min: limits.min + entityPositionY,
        max: limits.max + entityPositionY,
    };
    return limits;
};
const productSnapsInAccordanceWithPlacement = (product, Snap, placement) => {
    var _a, _b, _c;
    const { productAlignment, zone } = placement;
    const zoneLimitsAbsolute = getAbsoluteLimits(Snap.host, zone);
    if (!zoneLimitsAbsolute)
        return false;
    const productHeight = (_c = (_b = (_a = product.getComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.polyhedron) === null || _b === void 0 ? void 0 : _b.axisAlignedBoundingBox) === null || _c === void 0 ? void 0 : _c.height;
    if (!productHeight)
        return false;
    const candidatePosition = Snap.endTransform.position.Y;
    let minFulfilled = false;
    let maxFulfilled = false;
    switch (productAlignment) {
        case Alignment.Top:
            minFulfilled =
                candidatePosition + productHeight / 2 >= zoneLimitsAbsolute.min;
            maxFulfilled =
                candidatePosition + productHeight / 2 <= zoneLimitsAbsolute.max;
            break;
        case Alignment.Center:
            minFulfilled = candidatePosition >= zoneLimitsAbsolute.min;
            maxFulfilled = candidatePosition <= zoneLimitsAbsolute.max;
            break;
        case Alignment.Bottom:
            minFulfilled =
                candidatePosition - productHeight / 2 >= zoneLimitsAbsolute.min;
            maxFulfilled =
                candidatePosition - productHeight / 2 <= zoneLimitsAbsolute.max;
            break;
        case Alignment.Entire:
            minFulfilled =
                candidatePosition - productHeight / 2 >= zoneLimitsAbsolute.min;
            maxFulfilled =
                candidatePosition + productHeight / 2 <= zoneLimitsAbsolute.max;
            break;
        case Alignment.Partial:
        default:
            minFulfilled =
                candidatePosition + productHeight / 2 >= zoneLimitsAbsolute.min;
            maxFulfilled =
                candidatePosition - productHeight / 2 <= zoneLimitsAbsolute.max;
    }
    return minFulfilled && maxFulfilled;
};
const productSnapsAtValidHeight = (product, Snap, validPlacements) => validPlacements.some((placement) => productSnapsInAccordanceWithPlacement(product, Snap, placement));
export { productSnapsAtValidHeight };
